import './ConfirmDialog.scss'
import Close from "@mui/icons-material/Close";
import { Dialog } from "@mui/material";
import React from "react";
import { DangerButton, PrimaryButton, TertiaryButton } from "./Buttons";

export type ConfirmDialogProps = {
  dialogVisible?: boolean;
  toggleDialog?: () => void;
  title?: string;
  primaryButtonEnabled?: boolean;
  primaryButtonText?: string;
  secondaryButtonEnabled?: boolean;
  secondaryButtonText?: string;
  OnPrimaryButtonClick?: () => void;
  OnSecondaryButtonClick?: () => void;
  isPrimaryDanger?: boolean;
  className?: string;
  width?: number | string;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = (
  {
    dialogVisible,
    toggleDialog,
    title,
    OnPrimaryButtonClick,
    primaryButtonEnabled = true,
    primaryButtonText,
    OnSecondaryButtonClick,
    secondaryButtonEnabled = true,
    secondaryButtonText,
    children,
    isPrimaryDanger,
    className,
    width = 816
  }
) => {

  return (
    <>
      {dialogVisible &&
        <Dialog
          open
          className={`v3-dialog${className ? ` ${className}` : ''}`}
          onClose={toggleDialog}
          PaperProps={{ style: { width: typeof width === 'number' ? `${width}px` : width } }}
        >
          <div className='dialog-header'>
            <div className='dialog-title'>
              {title}
            </div>
            <button className='dialog-close' onClick={toggleDialog} type='button'>
              <span className='dialog-close-icon'><Close /></span>
            </button>
          </div>
          <div className='dialog-body'>
            {children}
          </div>
          <div className="dialog-footer">
            {secondaryButtonText &&
              <TertiaryButton className={`centered ${secondaryButtonEnabled ? '' : 'disabled'}`}
                onClick={OnSecondaryButtonClick}>
                <div className='title'>
                  {secondaryButtonText}
                </div>
              </TertiaryButton>
            }
            {primaryButtonText &&
              (
                !isPrimaryDanger ?
                  <PrimaryButton className={`centered ${primaryButtonEnabled ? '' : 'disabled'}`}
                    onClick={OnPrimaryButtonClick}>
                    <div className='title'>
                      {primaryButtonText}
                    </div>
                  </PrimaryButton>
                  :
                  <DangerButton className={`centered ${primaryButtonEnabled ? '' : 'disabled'}`}
                    onClick={OnPrimaryButtonClick}>
                    <div className='title'>
                      {primaryButtonText}
                    </div>
                  </DangerButton>
              )
            }
          </div>
        </Dialog>
      }
    </>
  )

}